import { render } from "./CartPage.vue?vue&type=template&id=6171e254&scoped=true"
import script from "./CartPage.vue?vue&type=script&lang=js"
export * from "./CartPage.vue?vue&type=script&lang=js"

import "./CartPage.vue?vue&type=style&index=0&id=6171e254&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6171e254"]])

export default __exports__